<template>
  <div>
    <custom-email
      :company="company"
      :ks-expiration="ksExpiration"
      :category="category"
      :created="created"
      :active="isActive"
      @update="update"
    />
  </div>
</template>

<script>
import CustomEmail from './custom-email/custom-email.vue';

export default {
  components: {
    CustomEmail,
  },
  props: {
    ksTemplates: {
      type: Array,
      default: () => [],
    },
    category: {
      type: Number,
      required: true,
    },
    company: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      created: false,
      ksExpiration: null,
      categoryName: null,
      isActive: false,
    };
  },
  mounted() {
    this.categoryName = { 1: 'assignment', 2: 'pending', 3: 'expiration', 4: 'answered' };
    this.isActive = this.ksExpiration?.state === 'active';
  },
  beforeMount() {
    this.ksExpiration = this.ksTemplates.find(t => t.category === 'expiration');
    if (this.ksExpiration) this.created = true;
  },
  methods: {
    update() {
      this.$emit('update');
    },
  },
};
</script>

<style>

</style>
